var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 47.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0060ab;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "waveMiddle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,411.76l6.5-.67c6.5-.67,19.5-2,32.5-.13s26,6.91,39,7.35,26-3.74,39.2-5,26.5.36,39.6,1.87S183,418,196,417.87s26-1.78,39-1.07,26,3.88,39,4.19,26-2.23,39-2,26,3.17,39,2.28,26-5.62,39-7.94,26-2.14,39.2-.76,26.5,4.1,39.6,6.2A384,384,0,0,0,509,423a203.63,203.63,0,0,0,39-1.34c13-1.87,26-5.44,39-5.66s26,2.89,39,1.87,26-6.24,39-6.11,26,5.66,39,8.25,26,2.32,39.2.13,26.5-6.15,39.6-5.48,26.2,6,39.2,6.46,26-4,39-6.11,26-1.78,32.5-1.6l6.5.13V451H0Z",
    transform: "translate(0 -400)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMiddle);
export default __webpack_public_path__ + "static/media/waveMiddle.4158a79a103d039198b6f888f09d2d1b.svg";
export { ForwardRef as ReactComponent };